import { render, staticRenderFns } from "./SearchDataProductModal.vue?vue&type=template&id=09479fa0&"
import script from "./SearchDataProductModal.vue?vue&type=script&lang=js&"
export * from "./SearchDataProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports